export default __webpack_public_path__ + "static/media/NYTimes.c8aaea30.svg";